export default "/student-copyright-checklist";